import axios from 'axios'
import { Message } from 'element-ui'

const instance = axios.create({
  timeout: 15000
});

instance.interceptors.request.use(config => {
  config.headers = config.headers || {}
  config.headers['Content-Type'] = 'application/json-patch+json'
  config.headers['accept'] = 'text/plain'
  config.headers['Authorization'] = sessionStorage.getItem('token') || ''
  config.headers['Access-Control-Allow-Origin'] = "*"
  return config;
}, err => {
  Message.error('网络异常，请重新操作！');
  return Promise.reject(err);
})

instance.interceptors.response.use(result => {
  let isDownLoad = result.config.url.indexOf('/api/Files/GetFileById') == -1
  if(result.data.code !== 'OK' && isDownLoad) {
    Message.error(result.data.msg);
    // if(result.data.errno === 1000) {
    //   sessionStorage.clear()
    //   router.replace('/login')
    // }
  }
  return result.data;
}, err => {
  if(err.message.includes('timeout')){   // 判断请求异常信息中是否含有超时timeout字符串
    Message.error('请求超时，请稍后再试！')
    return Promise.reject(err);
  }
  if(err.response.data.msg) {
    Message.error(err.response.data.msg);
  } else {
    Message.error('网络异常，请重新操作！')
  }
  
  return Promise.reject(err);
})

export default instance;